<form #form="ngForm" class="form-add-item">
	<div class="text">
		<span class="h4">
			<input
				#input="ngModel"
				[(ngModel)]="name"
				id="name"
				name="name"
				(stagesKeyUp)="onKeyUp($event)"
				(input)="change()"
				(blur)="blur()"
				required
				[attr.placeholder]="placeholder()"
				[stagesMaxLength]="maxLength()"
				pattern="{{ pattern() || '.*' }}"
			/>
		</span>
		<div class="info">
			<!-- workaround maybe better with FormService.setServerSideErrorsOnFormControls but has to be handled in dataview component -->
			@if (itemExist) {
				<div class="errors error" [translate]="existsMessageKey"></div>
			}
			@if (input.errors && wasNonEmpty && (input.dirty || input.touched)) {
				<div class="errors">
					@if (input.errors.required) {
						<div class="error" [translate]="'input.required'"></div>
					}
					@if (input.errors.max) {
						<div class="error" [translate]="'input.maxLength'" [translateParams]="{ length: maxLength() }"></div>
					}
					@if (input.errors.pattern && patternMessageKey) {
						<div class="error" [translate]="patternMessageKey"></div>
					}
					<!-- <div *ngIf="input.errors.exists" class="error" [translate]="existsMessageKey"></div> -->
				</div>
			}
			@if (hasCustomErrors() && (input.dirty || input.touched)) {
				<div class="errors">
					<ng-content></ng-content>
				</div>
			}
			<div class="max-length">{{ input.value?.length || 0 }}/{{ maxLength() }}</div>
		</div>
	</div>
</form>
